import type { DoctorLabel, DoctorRaw } from "./types";
import { LABEL } from "./terminology";

/**
 * Runtime Doctor display labels (Phase 3).
 * Pass | Warn | Fail | Not scanned — never Complete/Warning/Missing here
 * (those belong to onboarding checklist only).
 */
export function mapDoctorLabel(status: DoctorRaw): DoctorLabel {
  if (status == null || status === "") return LABEL.unknown as DoctorLabel;
  const s = String(status).trim().toLowerCase();
  if (s === "pass") return "Pass";
  if (s === "warn" || s === "warning") return "Warn";
  if (s === "fail" || s === "failed") return "Fail";
  if (s === "not_scanned" || s === "not scanned") return "Not scanned";
  return LABEL.unknown as DoctorLabel;
}

export type DoctorToneKey = "success" | "warning" | "danger" | "neutral";

export function doctorToneKey(label: DoctorLabel): DoctorToneKey {
  if (label === "Pass") return "success";
  if (label === "Warn") return "warning";
  if (label === "Fail") return "danger";
  return "neutral";
}

/** Compact icon glyphs for Runtime Doctor (shared visual language). */
export function doctorIcon(label: DoctorLabel): string {
  if (label === "Pass") return "✓";
  if (label === "Warn") return "!";
  if (label === "Fail") return "✕";
  if (label === "Not scanned") return "○";
  return "?";
}

/** Map fleet doctor verdict → platform health display (never "unhealthy"). */
export function mapDoctorVerdictToHealth(
  verdict: string | null | undefined,
): "Healthy" | "Degraded" | "Critical" | "Unknown" {
  if (verdict == null || verdict === "") return "Unknown";
  const s = String(verdict).trim().toLowerCase();
  if (s === "healthy" || s === "pass" || s === "ok") return "Healthy";
  if (s === "degraded" || s === "warn" || s === "warning") return "Degraded";
  if (s === "unhealthy" || s === "critical" || s === "fail" || s === "failed") {
    return "Critical";
  }
  return "Unknown";
}

/** Map raw doctor_status to onboarding checklist state (Complete/Warning/Missing). */
export function doctorToChecklistState(
  doctor: DoctorRaw,
): "complete" | "warning" | "missing" | "unknown" {
  if (!doctor || doctor === "not_scanned") return "missing";
  if (doctor === "pass") return "complete";
  if (doctor === "warn" || doctor === "fail") return "warning";
  return "unknown";
}
